module.exports = __webpack_public_path__ + "img/icon-nav2_hov.3e5112da.png";